import { Injectable } from '@angular/core';
import { IChannelLastRead, IChannelsResponse, IMessageHistory } from '@app/models/interfaces/chat.interface';
import { Types } from 'ably';
import { Observable } from 'rxjs';
import { ChatApiService } from './api/chat-api.service';
import { DataResponse, IScrollResponse } from '@app/models/interfaces/common.interface';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private chatApiService: ChatApiService
  ) { }

  removeChannelLocalStorage(channelId: string, userId: string): void {
    const key = `channel_lastread_${channelId}_${userId}`;
    localStorage.removeItem(key);
  }

  setChannelLocalStorage(channel: IChannelLastRead): void {
    const key = `channel_lastread_${channel.channelId}_${channel.userId}`;
    localStorage.setItem(key, JSON.stringify(channel));
  }
  getChannelLocalStorage(channelId: string, userId: string): IChannelLastRead {
    const key = `channel_lastread_${channelId}_${userId}`;
    const json = localStorage.getItem(key) || '';
    const channel = json ? JSON.parse(json) : undefined;
    return channel;
  }

  getChannelsApi(): Observable<IChannelsResponse> {
    return this.chatApiService.getChannelsApi();
  }

  getHistoriesChannelApi(channelId: string, timestamp: string): Observable<DataResponse<IScrollResponse<IMessageHistory>>> {
    return this.chatApiService.getHistoriesChannelApi(channelId, timestamp);
  }

  remindPatientChat(userId: string): Observable<any> {
    return this.chatApiService.remindPatientChat(userId);
  }
}
